import { render, staticRenderFns } from "./PropertyAlertForm.vue?vue&type=template&id=00310274"
import script from "./PropertyAlertForm.vue?vue&type=script&lang=js"
export * from "./PropertyAlertForm.vue?vue&type=script&lang=js"
import style0 from "./PropertyAlertForm.vue?vue&type=style&index=0&id=00310274&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports